import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { DashboardService } from '../../../service/events/dashboard.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { ImageMenuInterface } from './image-menu.interface';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
})
export class InicioComponent implements OnInit {
  public formacionUrl = environment.features.formacionUrl;

  public clientName = environment.features.clienteName;
  
  public userRol = StorageManager.getUser().rol;

  public userCanSeeClientes = environment.features.userCanSeeClientes || ['admin', 'responsable'].includes(this.userRol);
  
  public userCanSeeCostes = environment.features.userCanSeeCostes || this.userRol === 'admin';

  public cards: ImageMenuInterface[] = [];
    
  constructor(
  private readonly dashboard: DashboardService,
  private readonly router: Router,
  ) {
    // Prevent ESLint 'no-useless-constructor' warning
    void this.dashboard;
    void this.router;
  }


  ngOnInit(): void {
    this.dashboard.setMenuItem('inicio');
    this.initializeCards();
    this.redirectIfOnlyOneCard();
  }

  goto(id: string): void {
    this.router.navigate(['dashboard', id]);
  }
  
  private initializeCards(): void {
    const rol = this.userRol;

    this.cards = [
      { 
        id: 'usuarios', 
        title: 'Usuarios', src: 'assets/images/home_usuarios.jpg', visible: environment.features.showUsuarios && rol === 'admin' },
      { 
        id: 'clientes', 
        title: environment.features.clientesName, 
        src: 'assets/images/home_clientes.jpg', 
        visible: environment.features.hasClients && this.userCanSeeClientes,
      },
      { 
        id: 'finca', 
        title: environment.features.fincasName, 
        src: 'assets/images/home_fincas.jpg', 
        visible: environment.features.hasFincas,
      },
      { 
        id: 'campos', 
        title: 'Campos', 
        src: 'assets/images/home_fincas.jpg', 
        visible: environment.features.showCampos,
      },
      { 
        id: 'mapas', 
        title: 'Mapas', 
        src: 'assets/images/home_mapas.jpg', 
        visible: environment.features.showMapas,
      },
      { 
        id: 'ventas', 
        title: environment.features.ventasName, 
        src: 'assets/images/home_ventas.jpg', 
        visible: environment.features.showVentas,
      },
      { 
        id: 'mantenimiento', 
        title: environment.features.aplicadoresName, 
        src: 'assets/images/home_trabajadores.jpg', 
        visible: environment.features.hasAplicadores && environment.features.showTrabajadores,
      },
      { 
        id: 'maquinaria', 
        title: 'Maquinaria', 
        src: 'assets/images/home_maquinaria.jpg', 
        visible: environment.features.hasAplicadores && !environment.features.showTrabajadores,
      },
      { 
        id: 'productos-fitosanitarios', 
        title: 'Productos', 
        src: 'assets/images/home_productos.jpg', 
        visible: environment.features.hasProductos,
      },
      { 
        id: 'productos-s', 
        title: 'Productos', 
        src: 'assets/images/home_productos.jpg', 
        visible: environment.features.showProductosSimple,
      },
      { 
        id: 'consultas', 
        title: 'Vademecum', 
        src: 'assets/images/home_productos.jpg', 
        visible: environment.features.showVademecumMenu,
      },
      { 
        id: 'tratamientos', 
        title: 'Tratamientos', 
        src: 'assets/images/home_tratamientos.jpg', 
        visible: environment.features.showTratamientosMenu,
      },
      { 
        id: 'tratamientos-manez', 
        title: 'Tratamientos', 
        src: 'assets/images/home_tratamientos.jpg', 
        visible: environment.features.showTratamientosManezLozano,
      },
      { 
        id: 'tratamientos-control', 
        title: 'Control de tratamientos', 
        src: 'assets/images/calendario.jpg', 
        visible: environment.features.showTratamientosControl,
      },
      { 
        id: 'tareas', 
        title: 'Tareas', 
        src: 'assets/images/home_tareas.jpg', 
        visible: environment.features.showTareasFitosanitarias,
      },
      { 
        id: 'visitas', 
        title: 'Visitas', 
        src: 'assets/images/home_visitas.jpg', 
        visible: environment.features.showVisitas,
      },
      { 
        id: 'visitas-semana', 
        title: 'Visitas S.', 
        src: 'assets/images/home_visitas.jpg', 
        visible: environment.features.showVisitasPorSemana,
      },
      { 
        id: 'costes-fitosanitarios', 
        title: 'Costes', 
        src: 'assets/images/home_costos.jpg', 
        visible: environment.features.showCostes && this.userCanSeeCostes,
      },
      { 
        id: 'stock', 
        title: 'Stock', 
        src: 'assets/images/home_stock.jpg', 
        visible: environment.features.showStock,
      },
      { 
        id: 'albaranes', 
        title: 'Albaranes', 
        src: '', 
        visible: environment.features.showAlbaranes,
      },
    ];
  }

  private redirectIfOnlyOneCard(): void {
    const visibleCards = this.cards.filter(card => card.visible);

    if (visibleCards.length === 1) {
      this.router.navigate(['dashboard', visibleCards[0]?.id]);
    }
  }
}
